import { render, staticRenderFns } from "./upgrade-detail.vue?vue&type=template&id=03f8b7ae&scoped=true"
import script from "./upgrade-detail.vue?vue&type=script&lang=js"
export * from "./upgrade-detail.vue?vue&type=script&lang=js"
import style0 from "./upgrade-detail.vue?vue&type=style&index=0&id=03f8b7ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f8b7ae",
  null
  
)

export default component.exports